/* Contrat de chat partagé par le web et le mobile. */

/*
 * DÉRIVÉ du domaine, jamais recopié. L'union avait été recopiée à quatre valeurs
 * quand le domaine en portait sept, et les tables ci-dessous étant indexées
 * dessus, un fil `teacher` s'affichait sans icône et avec un libellé `undefined`
 * — 49 fils dans ce cas sur staging. Rien ne signalait l'écart : le `Record`
 * garantit qu'aucun mode DÉCLARÉ ne manque de rendu, pas que l'union suive la
 * base. Dériver ferme ce chaînon — ajouter un mode au domaine casse désormais la
 * compilation ici tant que son icône et son libellé manquent.
 */
export type { ChatMode } from '@naia-app/domain';
import type { ChatMode } from '@naia-app/domain';

/*
 * Les modes qu'un client peut CRÉER, sous-ensemble de ceux qu'il peut afficher.
 * `teacher` et `admin` naissent de leurs propres surfaces, et `student` du
 * routeur parent/tuteur, qui porte le contrôle du lien parent↔enfant : passer
 * par la création générique le contournerait.
 */
export type CreatableChatMode = Extract<ChatMode, 'general' | 'parcours' | 'voice' | 'cours'>;

/** Emoji icon per mode — shared UI constant (was duplicated on the web side). */
export const CHAT_MODE_ICON: Record<ChatMode, string> = {
  general: '💬',
  parcours: '📚',
  voice: '🎤',
  cours: '📖',
  teacher: '🧑‍🏫',
  admin: '🛠️',
  student: '🎒',
};

/** Short French label per mode (header badges, thread lists). */
export const CHAT_MODE_LABEL: Record<ChatMode, string> = {
  general: 'Chat libre',
  parcours: 'Parcours',
  voice: 'Vocal',
  cours: 'Cours',
  teacher: 'Assistant',
  admin: 'Labo',
  student: 'Élève',
};

export interface ChatThread {
  id: string;
  user_id: string;
  mode: ChatMode;
  parcours_id: string | null;
  document_id: string | null;
  title: string;
  last_message_at: string;
  created_at: string;
}

export interface ChatAttachment {
  url: string;
  mime: string;
  storagePath?: string;
}

export type WidgetToolName = 'render_widget' | 'ask_mcq' | 'render_interactive';

/** A widget the model asked to render, forwarded over the `widget` SSE event. */
export interface WidgetEvent {
  name?: WidgetToolName;
  toolCallId?: string;
  interactive?: boolean;
  args?: unknown;
  html?: string;
  title?: string;
  /** True when emitted by a live voice session (answer rides the open WS). */
  voice?: boolean;
}

export interface ChatMessage {
  id: string;
  thread_id: string | null;
  role: 'user' | 'assistant';
  transcript: string;
  attachments: ChatAttachment[] | null;
  /** UI-only: widgets split out of `attachments` on load. */
  widgets?: WidgetEvent[];
  /** Tool calls of the turn (cours mode), persisted for chip replay. */
  metadata?: { tools?: unknown[] } | null;
  created_at: string;
}
